import React, { useContext, useEffect, useState } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import api from '../../services/api'
import { displayMessage } from '../../helpers/messages'
import SL_Button from '../../components/buttons/Button'
import CreateUser from './components/CreateUserAdministrator'
import { ResetUserPasswordModal } from './components/ResetUserPasswordModal'
import { CloseOutlined, EditOutlined, ExclamationCircleOutlined, FilterOutlined, LockOutlined, UserAddOutlined } from '@ant-design/icons'
import UserFilters from '../../components/filters/UserFilters '
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from '../../services/styles';
import { Button, Popconfirm } from 'antd'
import column_grid_user_list from '../grid_columns/column_grid_user_administrator_list'
import { SL_Grid } from '../../components/grid/SL_Grid'
import { ColumnButtonCofirm } from '../../components/grid/ColumnButtonCofirm'


const { tc1, tc2, bc1, bc6 } = styles


export default function ListUsersAdministrator() {
    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const only_interest_users = params.get('only_interest_users');

    const [users, setUsers] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [isModalCreateUserVisible, setIsModalCreateUserVisible] = useState(false)
    const [isModalResetPasswordVisible, setIsModalResetPasswordVisible] = useState(false)
    const [isFiltersVisible, setIsFiltersVisible] = useState(false)

    const gridRef = useGridApiRef()
    
    const {
        setShowLoading,
        windowWidth,
        windowHeight,
        mobile_mode,
    } = useContext(GeneralContext)

    useEffect(() => {
        loadUserData()
    }, [only_interest_users])

    const loadUserData = async () => {
        try {
            setShowLoading(true)

            loadUsers()
            setCurrentUser(null)
        } finally {
            setShowLoading(false)
        }
    }

    const onSearchUsers = (values) => {
        loadUsers(values)
    }

    async function loadUsers(values) {
        if(only_interest_users){
            values = { ...values, only_interest_users }
        }
        const rs = await api.user.listAdmin(values)
        gridRef.current.setSelectionModel([])
        setUsers(rs.data)
    }

    const handleRowChange = (e) => {
        setCurrentUser(e?.row)
    }

    const handleOnCloseModalCreateUser = async (loadData) => {
        if (loadData) {
            await loadUsers()
        }

        setIsModalCreateUserVisible(false)
    }

    const handleOnOpenModalCreateUser = () => {
        setIsModalCreateUserVisible(true)
    }


    const handleOnGoToDetailUser = () => {
        navigate('' + currentUser.id)
    }

    const handleOnOpneFilters = () => {
        setIsFiltersVisible(true)
    }
    const handleOnCloseFilters = () => {
        setIsFiltersVisible(false)
    }

    const toggleActiveState = async (info) => {
        setShowLoading(true)

        try {
            if (!info?.id) {
                alert(displayMessage('ERROR_UPDATE_CLIENT_STATUS'), 'error', displayMessage('ERROR'))
                return
            }

            await api.user.changeActive(info.id)

            await loadUsers()
        } finally {
            setShowLoading(false)
        }
    }

    const toggleNeedAppointment = async ({ id }) => {
        setShowLoading(true)

        try {
            if (!id) {
                return
            }

            await api.user.changeNeedAppointment(id)
            await loadUsers()
        } finally {
            setShowLoading(false)
        }
    }

    const handleOnOpenModalResetPassword = () => {
        setIsModalResetPasswordVisible(true)
    }
    const handleOnCloseModalResetPassword = () => {
        setIsModalResetPasswordVisible(false)
    }

    
    return (
        <>
            {isModalCreateUserVisible && <CreateUser handleOnCloseModal={handleOnCloseModalCreateUser} refreshUsers={loadUserData} />}
            {isModalResetPasswordVisible && <ResetUserPasswordModal user={currentUser} onCloseModal={handleOnCloseModalResetPassword} />}
            <div className="flex flex-col flex-1 h-full">
                <div className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}>

                    <div className='self-center text-white font-semibold text-base'>{displayMessage('ADMINISTRATOR_LIST')}</div>

                    <div className={`flex-1 flex flex-wrap gap-2 justify-end`}>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalResetPassword}
                            disabled={!currentUser}
                            icon={<LockOutlined className='text-fit-blue-800 text-base flex items-center' />}

                        >
                            <span className='text-fit-blue-800 font-semibold flex-1' >
                                {displayMessage('REQUEST_PASSWORD_RESET')}
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnGoToDetailUser}
                            disabled={!currentUser || currentUser == null}
                            icon={<EditOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                {displayMessage('DETAIL_ADMINISTRATOR')}
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalCreateUser}
                            icon={<UserAddOutlined className='text-fit-red-800 text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                {displayMessage('CREATE_ADMINISTRATOR')}
                            </span>
                        </SL_Button>

                        <Button
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            type='default'
                            shape="circle"
                            onClick={isFiltersVisible ? handleOnCloseFilters : handleOnOpneFilters}
                            icon={!isFiltersVisible ? <FilterOutlined className='text-fit-red-800 text-base flex items-center' /> : <CloseOutlined className='text-fit-red-800 text-base flex items-center' />}
                        >
                        </Button>
                    </div>
                </div>
                {
                    isFiltersVisible ?
                        <UserFilters handleOnSearchUsers={loadUserData} onSearchUsers={onSearchUsers} filterHeight={'20vh'} />
                        :
                        <div />
                }
                <div className={`w-full flex-1 min-h-[400px] smb:min-h-0`} >
                    <SL_Grid
                        rows={users ?? []}
                        apiRef={gridRef}
                        columns={column_grid_user_list}
                        onRowClick={handleRowChange}
                    />
                </div>
            </div>
        </>
    )
}
